import logger from '../common/logger'
import TrackingManager from '../guCommonTracking'

const AWIN_ADVERTISER_ID = '99907'
const AWIN_AFFILIATE_ID = '30966'

const module = 'AwinTracker'
const AwinTracker = {
  pixelConfig: null,
  enabled: false,
  consentGranted: false,
  load: () => {
    try {
      var masterTag = document.createElement('script')
      masterTag.setAttribute('defer', 'defer')
      masterTag.src = `https://www.dwin1.com/${AWIN_ADVERTISER_ID}.js`
      masterTag.type = 'text/javascript'
      document.getElementsByTagName('body')[0].appendChild(masterTag)

      AwinTracker.enabled = true
    } catch (e) {
      logger.error('load failed', e, { module })
    }
  },
  grantConsent: () => {
    AwinTracker.consentGranted = true
  },
  trackEvent: (eventProperties) => {
    try {
      if (!AwinTracker.enabled) {
        return
      }
      const eventName = eventProperties.eventName
      if (eventName == 'Order Conversion') {
        AwinTracker.trackConversion(eventProperties)
      }
      // Implement non-conversion events here if needed in the future
    } catch (e) {
      logger.error('trackEvent failed', e, { module })
    }
  },
  trackConversion: (eventProperties) => {
    try {
      if (!AwinTracker.enabled || !AwinTracker.consentGranted) {
        return
      }

      let { propertyMeta, propertyValue } = eventProperties

      const oid =
        window?.gu_qs?.oid && window?.gu_qs?.oid != ''
          ? window?.gu_qs?.oid
          : TrackingManager.config?.offer_id ?? null

      const masterTagLoaded =
        typeof window.AWIN != 'undefined' &&
        typeof window.AWIN.Tracking != 'undefined'

      if (!masterTagLoaded) {
        window.AWIN = window.AWIN || {}
        window.AWIN.Tracking = window.AWIN.Tracking || {}
      }

      const saleAmount = parseFloat(propertyValue).toFixed(2)

      const isAwinReferral = window.gu_qs?.aff_id === AWIN_AFFILIATE_ID

      window.AWIN.Tracking.Sale = {}
      window.AWIN.Tracking.Sale.amount = saleAmount
      window.AWIN.Tracking.Sale.channel = isAwinReferral ? 'aw' : 'other'
      window.AWIN.Tracking.Sale.orderRef =
        propertyMeta.friendly_id || propertyMeta.id
      window.AWIN.Tracking.Sale.parts = `GU${oid}:${saleAmount}`
      window.AWIN.Tracking.Sale.currency = 'USD'
      window.AWIN.Tracking.Sale.voucher = ''
      window.AWIN.Tracking.Sale.test = '0'

      if (masterTagLoaded) {
        window.AWIN.Tracking.run()
      }
    } catch (e) {
      logger.error('trackConversion failed', e, { module })
    }
  },
}
export default AwinTracker
